import { delay } from "../../../hooks/utils/TimeUtils";

export interface IAlertType {
  message: string;
  type: "alert-danger" | "alert-warning" | "alert-info" | "alert-success";
}

type Subscriber = (alerts: IAlertType[]) => void;

class GlobalErrors {
  private alerts: IAlertType[] = [];
  private deletionScheduled: boolean = false;
  private subscribers: Set<Subscriber> = new Set();

  private notify(): void {
    // Spread to give React a new array reference, triggering re-render
    this.subscribers.forEach(fn => fn([...this.alerts]));
  }

  public subscribe(fn: Subscriber): () => void {
    this.subscribers.add(fn);
    fn([...this.alerts]); // emit current state immediately on subscribe
    return () => this.subscribers.delete(fn); // returns unsubscribe
  }

  private async deletionLoop(): Promise<void> {
    while (this.alerts.length > 0) {
      await delay(5000);
      this.alerts.shift();
      this.notify();
    }
    this.deletionScheduled = false;
  }

  public addAlert(alert: IAlertType): void {
    this.alerts.push(alert);
    this.notify();

    if (!this.deletionScheduled) {
      this.deletionScheduled = true;
      this.deletionLoop();
    }
  }

  public removeAlert(index: number): void {
    this.alerts.splice(index, 1);
    this.notify();
  }
}

export const globalErrors = new GlobalErrors();